import { render, staticRenderFns } from "./DisplayErrorsInline.vue?vue&type=template&id=10644722&scoped=true"
import script from "./DisplayErrorsInline.vue?vue&type=script&lang=ts"
export * from "./DisplayErrorsInline.vue?vue&type=script&lang=ts"
import style0 from "./DisplayErrorsInline.vue?vue&type=style&index=0&id=10644722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10644722",
  null
  
)

export default component.exports